import React from 'react'
import PropTypes from 'prop-types'
import { getText } from '../../../internal/TextLabels/text'

export const ChatStatus = props => {
  if (props.statusText) {
    return (
      <div style={{ marginBottom: '.5rem', fontSize: '1.2rem' }}>
        <strong>
          {getText('chat.agent')}: {props.statusText}
        </strong>
      </div>
    )
  }
  return null
}

ChatStatus.propTypes = {
  statusText: PropTypes.string,
}

ChatStatus.defaultProps = {
  statusText: null,
}
